export default {
    methods: {
        // 选择图片
        selectPicture(item) {
            this.photoGalleryVisible = true;
            this.curSelectItem = item;
        },
        // 选择图片返回
        photoGalleryChange(data) {
            this.photoGalleryVisible = false;
            if(data) {
                const params = {
                    imageUrl: data.imageUrl,
                    id: this.curSelectItem.id
                }
                this.replaceIcon(params)
            }
        }
    }
}